import { render, staticRenderFns } from "./GiftingServices.vue?vue&type=template&id=d92ab72a&scoped=true&"
import script from "./GiftingServices.vue?vue&type=script&lang=js&"
export * from "./GiftingServices.vue?vue&type=script&lang=js&"
import style0 from "./GiftingServices.vue?vue&type=style&index=0&id=d92ab72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92ab72a",
  null
  
)

export default component.exports